<template>
  <b-list-group-item>
    {{this.updPLC.categoryname}}
    <a style="float: right;" :href="'#'+$route.path">
      <b-icon icon="x-circle" variant="danger" font-scale="1.5" v-b-popover.hover.right="'Remove Category from Printer Location'" @click="emitRemoveCategory"></b-icon>
    </a>
  </b-list-group-item>
</template>
<script>
export default {
  name: 'PLCategories',
  props: ['category', 'printerlocationid'],
  data () {
    return {
      updPLC: {
        printerlocationcategoryid: this.category.id,
        categoryid: this.category.categoryid,
        categoryname: this.category.categoryname,
        printerlocation: this.printerlocationid
    }
    }
  },
  methods: {
    emitRemoveCategory() {
      this.$emit('emit-remove-printer-location-category', this.updPLC.printerlocationcategoryid);
    },
  },
}
</script>

<style>
</style>
